import { getOrder } from "@api";

const loader = async ({ params }: any) => {
    const { orderId } = params;
    const [{ order }] = await Promise.all([getOrder(orderId)]);
    console.log(order);
    return {
        orderId,
        order,
        header: `Order #${orderId}`,
    };
};

export default loader;
